import { Injectable, signal } from '@angular/core';
import {
  SlimNavUpdate,
  VacationSearchInput
} from '../../models/nav-slim/nav-slim.interfaces';

@Injectable({ providedIn: 'root' })
export class NavSlimService {
  updateVacationData = signal<VacationSearchInput | undefined>(undefined);
  updateShoppingSlimNavData = signal<SlimNavUpdate | undefined>(undefined);

  /**
   * Updates the slim header cookie data without requiring a page refresh.
   *
   * Call this after the user submits a modified search in the vacation widget.
   * Since the updated cookie won't be read until the next page load, this method
   * allows the consumer to push the new search values directly so the slim header
   * reflects the latest state immediately.
   *
   * @param data - The updated vacation search values from the modify widget,
   *   including origin, destination, dates, rooms, adults, and children counts.
   */
  updateVacationInputData(data: VacationSearchInput) {
    this.updateVacationData.set(data);
  }

  /**
   * Triggers a slim nav update without requiring a page refresh.
   *
   * Call this after the user submits a modified flight search.
   * The effect in HeaderSlimBaseService will react and update navSlimDetails immediately.
   *
   * @param data - The updated slim nav values including optional origin, destination, and dates.
   */
  updateShoppingInputData(data: SlimNavUpdate) {
    this.updateShoppingSlimNavData.set(data);
  }
}
